import React, { useEffect, useMemo } from 'react'
import { Footer as DefignFooter, FOOTER_TYPE, FOOTER_QUICK_MENU_TITLE, FOOTER_QUICK_MENU_ITEM_MAP, GlobalConfig } from '@defign/ui'
import type { SyntheticEvent } from 'react'

import { handleNclick } from '@Helpers/nclick'
import { NCLICK } from '@Root/contants/lcs'
import { LAND_SERVICE_PREFIX_URL } from '@Root/contants/urlConstants'
import usePromotion from '@Hooks/myhouse/usePromotion'
import { MOBILE_REGEX } from '@Root/contants'

GlobalConfig.setPayDomain(process.env.REACT_APP_PAY_HOME_URL ?? '')

type Props = {
  show?: boolean
}

const Footer: React.FC<Props> = ({ show }: Props) => {
  const isLandApp = /\b(naverland_android|naverland_ios)\b/i.test(navigator.userAgent.toLowerCase())
  /* 무료보험 프로모션 추가부분 시작 */
  const { promotion, loadIsAppliedMember } = usePromotion()
  const { isAppliedMember } = promotion

  useEffect(() => {
    loadIsAppliedMember()
  }, [])
  /* 무료보험 프로모션 추가부분 끝 */

  const useAgentInfo: {
    isIOS: boolean
    isAndroid: boolean
    isPayApp: boolean
  } = useMemo(() => {
    return {
      isIOS: MOBILE_REGEX.IS_IPHONE.test(navigator.userAgent),
      isAndroid: MOBILE_REGEX.IS_ANDROID.test(navigator.userAgent),
      isPayApp: MOBILE_REGEX.IS_PAY_APP.test(navigator.userAgent),
    }
  }, [navigator.userAgent])

  if (!(show ?? true)) {
    return null
  }

  const commonMenuList = [
    {
      title: FOOTER_QUICK_MENU_TITLE.LOGOUT,
      href: '#',
      onClickLogout: (e: SyntheticEvent) => {
        e.preventDefault()

        handleNclick(NCLICK.MY_HOUSE.FOOTER.LOGOUT, e)

        window.location.href = `https://nid.naver.com/nidlogin.logout?svctype=262144&url=${process.env.REACT_APP_SPACE_WEB_URL ?? 'https://m.land.naver.com'}`
      },
    },
    {
      title: FOOTER_QUICK_MENU_TITLE.ALL_SERVICE,
      href: 'https://m.naver.com/services.html?f=svc.land',
      onClick: (e: SyntheticEvent) => handleNclick(NCLICK.MY_HOUSE.FOOTER.ALL_SERVICE, e),
    },
    {
      ...FOOTER_QUICK_MENU_ITEM_MAP.realEstate['부동산 도움말'],
      href: 'https://help.naver.com/alias/land/landmain.naver',
      onClick: (e: SyntheticEvent) => handleNclick(NCLICK.MY_HOUSE.FOOTER.HELP, e)
    },
    { ...FOOTER_QUICK_MENU_ITEM_MAP.realEstate['이용약관'], onClick: (e: SyntheticEvent) => handleNclick(NCLICK.MY_HOUSE.FOOTER.TERMS, e) },
    { ...FOOTER_QUICK_MENU_ITEM_MAP.realEstate['개인정보처리방침'], onClick: (e: SyntheticEvent) => handleNclick(NCLICK.MY_HOUSE.FOOTER.PERSONAL_DATA, e) },
  ]

  const overwriteMenuList = isAppliedMember
    ? [
        ...commonMenuList,
        {
          title: '우리집 화재보험 상세 안내',
          href: `${LAND_SERVICE_PREFIX_URL.MYHOUSE_PROMOTION_INSURANCE}/claim`,
        },
      ]
    : commonMenuList

  const overrideInfo = {
    logo: {
      onClick: (e: SyntheticEvent) => handleNclick(NCLICK.MY_HOUSE.FOOTER.NAVER_FINANCIAL, e),
    },
    cs: {
      onClick: (e: SyntheticEvent) => handleNclick(NCLICK.MY_HOUSE.FOOTER.INQUIRY, e),
    },
    NFBusinessInfo: {
      onClick: (e: SyntheticEvent) => handleNclick(NCLICK.MY_HOUSE.FOOTER.BUSINESS_INFO, e),
    },
  }

  return (
    <>
      {isLandApp ? (
        <DefignFooter
          type={FOOTER_TYPE.REAL_ESTATE}
          overwriteMenuList={[
            ...overwriteMenuList,
            { ...FOOTER_QUICK_MENU_ITEM_MAP.realEstate['오픈소스 라이선스'], onClick: (e: SyntheticEvent) => handleNclick(NCLICK.MY_HOUSE.FOOTER.OPEN_SOURCE, e) },
          ]}
          isLogin={true}
          isMobile={true}
          overrideInfo={overrideInfo}
          npayDownloadButtonProps={useAgentInfo}
        />
      ) : useAgentInfo.isAndroid ? (
        <DefignFooter
          type={FOOTER_TYPE.REAL_ESTATE}
          overwriteMenuList={overwriteMenuList}
          isLogin={true}
          isMobile={true}
          overrideInfo={overrideInfo}
          npayDownloadButtonProps={useAgentInfo}
        />
      ) : (
        <DefignFooter type={FOOTER_TYPE.REAL_ESTATE} overwriteMenuList={overwriteMenuList} isLogin={true} isMobile={true} overrideInfo={overrideInfo} npayDownloadButtonProps={useAgentInfo} />
      )}
    </>
  )
}

export default Footer
